import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Confidentiality = (props) => (
  <SvgIcon {...props} viewBox="0 0 25 23">
    <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.96802 19.8641C10.4722 20.7819 13.2762 20.9099 15.8804 20.2253C18.4847 19.5407 20.72 18.088 22.188 16.126C23.656 14.1641 24.2614 11.8203 23.8962 9.51241C23.5311 7.2045 22.2191 5.08238 20.1942 3.5242C18.1692 1.96602 15.5628 1.073 12.8393 1.00428C10.1159 0.935566 7.45236 1.69561 5.32339 3.14898C3.19442 4.60235 1.7383 6.65463 1.21452 8.94011C0.690738 11.2256 1.13331 13.5958 2.46338 15.6284L2.46336 22L7.96802 19.8641Z"
        stroke="currentColor"
      />
      <path d="M7 11H17.5" stroke="currentColor" strokeDasharray="2 2" />
    </svg>
  </SvgIcon>
);
export default Confidentiality;
